// Sentry React 兼容层 - Health 应用专用
// 这个文件模拟 @sentry/react 的导出，提供与原始 Sentry 相同的 API

import React from 'react';
import ErrorBoundary from './ErrorBoundary';

export const Sentry = {
  // 捕获消息
  captureMessage: (message: string, ...args: any[]) => {
    // 空实现，不执行任何操作
    console.log('[Sentry Mock] captureMessage:', message, ...args);
  },

  // 捕获异常
  captureException: (error: any, ...args: any[]) => {
    // 空实现，不执行任何操作
    console.log('[Sentry Mock] captureException:', error, ...args);
  },

  // 错误边界包装器
  withErrorBoundary: (Component: any, options: any) => {
    // 使用自定义的 ErrorBoundary 包装组件
    const WrappedComponent = (props: any) => (
      <ErrorBoundary fallback={options.fallback}>
        <Component {...props} />
      </ErrorBoundary>
    );
    return WrappedComponent;
  },

  // 初始化（空实现）
  init: (options: any) => {
    // 空实现
    console.log('[Sentry Mock] init called with options:', options);
  }
};

export default Sentry;
